module.exports = __webpack_public_path__ + "img/user-photo.ebe976c2.png";